module.exports = __webpack_public_path__ + "assets/img/travel-day49.cb262b3d.png";